var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolume = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8 14.703-.342-.303H3.6V9.6h4.058l.341-.304L13.058 4.8h.142v14.4h-.142zm-5.6.897h4.8l5.4 4.8h1.8V3.6h-1.8L7.2 8.4H2.4v7.2m15.36-.72A3.6 3.6 0 0 0 19.2 12a3.6 3.6 0 0 0-1.44-2.88l-.72.96c.582.438.96 1.136.96 1.92 0 .783-.378 1.48-.96 1.92zm2.16 2.88A7.19 7.19 0 0 0 22.8 12a7.19 7.19 0 0 0-2.88-5.76l-.72.96a5.99 5.99 0 0 1 2.4 4.8 5.99 5.99 0 0 1-2.4 4.8z"
  })));
};
export default SvgVolume;